import HeroSection from '@/components/feature/HeroSection';
import ProblemSection from '@/components/feature/ProblemSection';
import SolutionSection from '@/components/feature/SolutionSection';
import KurbanOperationsSection from '@/components/feature/KurbanOperationsSection';
import ComparisonSection from '@/components/feature/ComparisonSection';
import AdaklikSection from '@/components/feature/AdaklikSection';
import FeatureGridSection from '@/components/feature/FeatureGridSection';
import ModulesSection from '@/components/feature/ModulesSection';
import WhoIsItForSection from '@/components/feature/WhoIsItForSection';
import DashboardPreviewSection from '@/components/feature/DashboardPreviewSection';
import CustomerPortalSection from '@/components/feature/CustomerPortalSection';
import SecurityTrustSection from '@/components/feature/SecurityTrustSection';
import PricingCTASection from '@/components/feature/PricingCTASection';
import FAQSection from '@/components/feature/FAQSection';
import FinalCTASection from '@/components/feature/FinalCTASection';
import ContactSection from '@/components/feature/ContactSection';
import SEOTextSection from '@/components/feature/SEOTextSection';
import SiteHeader from '@/components/site/SiteHeader';
import SiteFooter from '@/components/site/SiteFooter';
import ResourceHub from '@/components/site/ResourceHub';
import Seo, { SiteSchema } from '@/components/site/Seo';
import ProductMediaSection from '@/components/feature/ProductMediaSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Seo title="Kurban ve Çiftlik Yönetim Sistemi | Hisse, Tahsilat, Kesim | CiftlikWeb" description="Kurbanlık satış ve hisse takip programı, çiftlik cari ve müşteri takip sistemi, dijital kesim sıramatiği ve mobil bulut yönetimi CiftlikWeb'de." path="/" />
      <SiteSchema />
      <SiteHeader />
      <main>
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <ProductMediaSection />
        <ResourceHub />
        <KurbanOperationsSection />
        <ComparisonSection />
        <AdaklikSection />
        <FeatureGridSection />
        <ModulesSection />
        <WhoIsItForSection />
        <DashboardPreviewSection />
        <CustomerPortalSection />
        <SecurityTrustSection />
        <PricingCTASection />
        <FAQSection />
        <FinalCTASection />
        <ContactSection />
        <SEOTextSection />
      </main>
      <SiteFooter />
    </div>
  );
}
